import React from 'react'
import PageTitle from '../components/PageTitle/PageTitle';
import Login1 from '../components/UI/Login1';
const Login = () => {
  return (
    <PageTitle title="Login">  
        <Login1/>
    </PageTitle>
  );
};

export default Login